import getExtensionVersionId from './get-extension-version-id';
import getExtensionSettings from './get-extension-settings';
import getExtension from './get-extension';

export default {
  getExtensionVersionId,
  getExtensionSettings,
  getExtension,
};
